'use strict';

var _ = require('underscore');
var Radio = require('backbone.radio');

var polyglot = require('../../utilities/polyglot').default;

var FormView = require('../form').default;

export default FormView.extend({

  className: 'form credit-card-form',
  template: require('./templates/form.hbs'),
  events: {
    'keyup #number,#exp,#name,#cvc': 'onKeyUp',
  },
  ui: {
    number: '#number',
    exp: '#exp',
    name: '#name',
    cvc: '#cvc',
    button: '#book-appointment-button',
  },
  masks: {
    number: '0000 0000 0000 0000',
    exp: '00 / 0000',
    cvc: '0000',
  },

  initialize: function () {
    this.listenTo(Radio.channel('steps'), 'click:book', this.onSubmit);
  },

  updateModel: function () {
    var exp = this.ui.exp.val().split(' / ');
    var exp_month = parseInt(exp[0]),
      exp_year = parseInt(exp[1]);

    var card = {
      number: this.ui.number.cleanVal(),
      exp_month: exp_month,
      exp_year: exp_year,
      name: this.ui.name.val(),
      cvc: this.ui.cvc.cleanVal(),
    };

    this.model.set(card);
  },

  focus: function () {
    this.ui.number.focus();
  },

});
